import classNames from 'classnames';
import { BackgroundThemeRevision, ColorId } from 'referral-types';
import { useMemo } from 'react';
import { useTheme } from '../../../../context/theme/useTheme';
import { getCssVariableForColorId } from '../../../../constants';

export enum SimpleGradientSubThemeIds {
  linearVertical = 'gradient-linear-vertical',
  linearHorizontal = 'gradient-linear-horizontal',
  linearDiagonal = 'gradient-linear-diagonal',
  radial = 'gradient-radial',
}

export const SimpleGradientSubThemeOptions = [
  { value: SimpleGradientSubThemeIds.linearVertical, label: 'Linear Vertical' },
  { value: SimpleGradientSubThemeIds.linearHorizontal, label: 'Linear Horizontal' },
  { value: SimpleGradientSubThemeIds.linearDiagonal, label: 'Linear Diagonal' },
  { value: SimpleGradientSubThemeIds.radial, label: 'Radial' },
];

export const SimpleGradientBackground = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;
  const { isDarkMode } = useTheme();
  const subTheme = (themeRevision?.subTheme as SimpleGradientSubThemeIds) || SimpleGradientSubThemeIds.linearVertical;

  const gradient = useMemo(() => {
    const colorId1 = themeRevision?.colorId1 || ColorId.Secondary2;
    const colorId2 = themeRevision?.colorId2 || ColorId.Secondary6;
    const cssVar1 = getCssVariableForColorId(colorId1, isDarkMode);
    const cssVar2 = getCssVariableForColorId(colorId2, isDarkMode);

    const c1 = `rgb(var(${cssVar1}))`;
    const c2 = `rgb(var(${cssVar2}))`;

    switch (subTheme) {
      case SimpleGradientSubThemeIds.linearHorizontal:
        return `linear-gradient(to right, ${c1} 0%, ${c2} 100%)`;
      case SimpleGradientSubThemeIds.linearDiagonal:
        return `linear-gradient(to bottom right, ${c1} 0%, ${c2} 100%)`;
      case SimpleGradientSubThemeIds.radial:
        return `radial-gradient(circle, ${c1} 0%, ${c2} 100%)`;
      case SimpleGradientSubThemeIds.linearVertical:
      default:
        return `linear-gradient(to bottom, ${c1} 0%, ${c2} 100%)`;
    }
  }, [themeRevision?.colorId1, themeRevision?.colorId2, subTheme, isDarkMode]);

  return <div className="relative -z-10 h-full w-full" style={{ background: gradient }} />;
};
